
import moment from "moment";
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import React, { useEffect, useState } from "react";
import { ApartmentBodyTemplate, CustomerTemplate, Date_CheckInBodyTemplate, Date_CheckOutBodyTemplate, ID_reservationBodyTemplate, statusBodyTemplate, Total_discound_valueBodyTemplate, Total_PaidBodyTemplate, Total_PriceBodyTemplate, View_count_days } from "../constants/dataView";
import view_day_ar from '../functions/view_day_ar';
import { getbookings_checkin_today, getbookings_checkout_today, getbookingsnow, getdatadashboard } from "../Helper/links";
import API from "../Helper/server/API";

function Home(e)
{

    const items = Array.from({ length: 3 }, (v, i) => i);
    const [dashbord, setDashbord] = useState({});
    const [bookingnow, setBookingnow] = useState([]);
    const [bookingntoday, setBookingtoday] = useState([]);
    const [CheckOutToday, setCheckOutToday] = useState([]);
    const [loading_checkin,set_loading_checkin]=useState(false);
    const [loading_checkout,set_loading_checkout]=useState(false);

    const [loading_info,set_loading_info]=useState(false);
    const GetInfoDashboard = async () =>
    {
        set_loading_info(true)
        const response = await API.get(getdatadashboard)
        if(response?.success===1)
        {
            setDashbord({
                treasury: response?.data?.treasury,
                count_payments: response?.data?.count_payments,
                total_amount_push: response?.data?.total_amount_push,
                count_payments_push: response?.data?.count_payments_push,
                total_amount_withdraw: response?.data?.total_amount_withdraw,
                count_payments_withdraw: response?.data?.count_payments_withdraw,
                count_reservationes: response?.data?.count_reservationes,
                count_apartments: response?.data?.count_apartments
            });
            setBookingtoday(response?.data?.in);
            setCheckOutToday(response?.data?.out);
            setBookingnow(response?.data?.now);

        }
        set_loading_info(false)

    }
    const scrollStyle = {
        overflowY: "auto",
        scrollbarWidth: "thin", // للمتصفحات غير Chrome

    };
    const scrollBarCSS = `
   ::-webkit-scrollbar {
        display: block !important;
        width: 5px;
        height: 8px;
    }
    `;

    useEffect(() =>
    {
        GetInfoDashboard();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (
    <div className="page-wrapper">
        <div className="content-wrapper" dir='rtl'>
            <div className="page-content fade-in-up">
                <div className="row">

                    <div className="col-lg-3 col-md-6" >
                        <div className="ibox bg-success color-white widget-stat">
                            <div className="ibox-body">
                                <i className="fa fa-money widget-stat-icon"></i>
                                <h4 className="m-b-5 font-strong">الخزينة</h4>
                                <h4 className="m-b-5 font-strong">
                                    {
                                        dashbord.treasury ?
                                        (
                                            dashbord.treasury + " د.ل"
                                        )
                                        :
                                        (<>0 د،ل</>)
                                    }
                                </h4>
                                <div>
                                    <i className="fa fa-level-up m-r-5"></i>
                                    {
                                        dashbord.count_payments ?
                                        (

                                                <small>{dashbord.count_payments} فاتورة </small>

                                        )
                                        :
                                        (null)
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="ibox bg-warning color-white widget-stat">
                            <div className="ibox-body">
                                <i className="fa fa-money widget-stat-icon"></i>
                                <h4 className="m-b-5 font-strong">دفع</h4>
                                <h3 className="m-b-5 font-strong">
                                    {
                                        dashbord.total_amount_push ?
                                        (
                                            dashbord.total_amount_push + " د.ل"
                                        )
                                        :
                                        (<>0 د،ل</>)
                                    }
                                </h3>
                                <div>
                                    <i className="fa fa-level-up m-r-5"></i>
                                {
                                    dashbord.count_payments_push ?
                                    (
                                        <small>{dashbord.count_payments_push} فاتورة </small>
                                    )
                                    :
                                    (null)
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="ibox bg-danger color-white widget-stat">
                            <div className="ibox-body">
                                <i className="fa fa-money widget-stat-icon"></i>
                                <h4 className="m-b-5 font-strong">استرداد</h4>
                                <h3 className="m-b-5 font-strong">
                                    {
                                        dashbord.total_amount_withdraw ?
                                        (
                                            dashbord.total_amount_withdraw + " د.ل"
                                        )
                                        :
                                        (<>0 د،ل</>)
                                    }
                                </h3>
                                <div>
                                    <i className="fa fa-level-up m-r-5"></i>
                                    {
                                        dashbord.count_payments_withdraw ?
                                        (

                                                <small>{dashbord.count_payments_withdraw} فاتورة </small>

                                        )
                                        :
                                        (null)
                                    }
                                 </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="ibox bg-info color-white widget-stat">
                            <div className="ibox-body">
                                <i className="ti-bar-chart widget-stat-icon"></i>
                                <h4 className="m-b-5 font-strong">
                                    حجوزات جديدة
                                </h4>
                                <h4 className="m-b-5 font-strong">
                                    {
                                        dashbord.count_reservationes ?
                                        (
                                            dashbord.count_reservationes + " حجوزات"
                                        )
                                        :
                                        (<>0</>)
                                    }
                                </h4>
                                <div>
                                    <i className="fa fa-level-up m-r-5"></i>
                                    {
                                        dashbord.count_apartments ?
                                        (

                                                <small>{dashbord.count_apartments} شاليهات </small>

                                        )
                                        :
                                        (null)
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <div className="ibox">
                            <div className="ibox-head">
                            <div className="ibox-title">أستقبــال الحجـــوزات اليــوم</div>
                                <button className="btn btn-info btn-sm" >
                                    {moment(new Date()).format('yyyy-MM-DD')}
                                    <br></br>
                                    {view_day_ar(new Date())}
                                </button>
                            </div>
                            <div className="ibox-body" >
                                {
                                    loading_checkin ?
                                        <DataTable value={items}
                                            selectionMode="multiple"
                                            metaKeySelection={false} dragSelection
                                            stripedRows removableSort
                                            // paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                            scrollable scrollHeight="300px"
                                            sortMode="multiple"
                                            className="custom-scrollbar"
                                            size="small"
                                            emptyMessage={<center><h5> لا يــوجد أستقبــال اليــوم اليــوم</h5></center>}
                                            tableStyle={scrollStyle}
                                            style={{fontFamily:"Cairo",direction:"rtl",fontSize: "15px",border: "10px"}}
                                        >
                                            <Column field="ID_reservation" body={<Skeleton />} header="الحجز" sortable style={{ width: '2%',textAlign:"right" }}></Column>
                                            <Column field="visitor_name" body={<Skeleton />}  header="العميــل" sortable style={{ width: '10%',textAlign:"right" }}></Column>
                                            <Column field="number" header="الاقامة"  showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                            body={<Skeleton />}  sortable style={{ width: '5%',textAlign:"right" }}></Column>
                                            <Column field="date_check_in" header="عدد الايام" body={<Skeleton />}   style={{ width: '7%',textAlign:"right" }}></Column>
                                            <Column header="الباقي" field="rest" body={<Skeleton />}  sortable style={{ width: '5%',textAlign:"right",color:"red" }} ></Column>
                                            <Column field="notes" header="ملاحظات" body={<Skeleton />}  style={{ width: '5%',textAlign:"right" }}></Column>
                                        </DataTable>
                                        :
                                        <DataTable value={bookingntoday} loading={loading_checkin}
                                            dataKey="ID_reservation"
                                            selectionMode="multiple"
                                            metaKeySelection={false} dragSelection
                                            stripedRows removableSort
                                            // paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                            scrollable scrollHeight="300px"
                                            sortMode="multiple"
                                            className="custom-scrollbar"
                                            size="small"
                                            emptyMessage={<center><h5> لا يــوجد أستقبــال اليــوم اليــوم</h5></center>}
                                            tableStyle={scrollStyle}
                                            style={{fontFamily:"Cairo",direction:"rtl",fontSize: "15px",border: "10px"}}
                                        >
                                            <Column field="ID_reservation" body={ID_reservationBodyTemplate}  header="الحجز" sortable style={{ width: '2%',textAlign:"right" }}></Column>
                                            <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%',textAlign:"right" }}></Column>
                                            <Column field="number" header="الاقامة"  showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                            body={ApartmentBodyTemplate} sortable style={{ width: '5%',textAlign:"right" }}></Column>
                                            <Column field="date_check_in" header="عدد الايام" body={View_count_days}  style={{ width: '7%',textAlign:"right" }}></Column>
                                            <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '5%',textAlign:"right",color:"red" }} ></Column>
                                            <Column field="notes" header="ملاحظات" style={{ width: '5%',textAlign:"right" }}></Column>
                                        </DataTable>

                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="ibox">
                            <div className="ibox-head">
                                <div className="ibox-title">مغــادرة الحجـــوزات اليــوم</div>
                                <button className="btn btn-info btn-sm"  >
                                     {moment(new Date()).format('yyyy-MM-DD')}
                                    <br></br>
                                    {view_day_ar(new Date())}
                                </button>

                            </div>
                            <div className="ibox-body">
                            {
                            loading_checkout ?
                                <DataTable value={items}
                                    selectionMode="multiple"
                                    metaKeySelection={false} dragSelection
                                    stripedRows removableSort
                                    // paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                    scrollable scrollHeight="300px"
                                    sortMode="multiple"
                                    className="custom-scrollbar"
                                    size="small"
                                    emptyMessage={<center><h5> لا يــوجد مغــادرة اليــوم</h5></center>}
                                    tableStyle={scrollStyle}
                                    style={{fontFamily:"Cairo",direction:"rtl",fontSize: "15px",border: "10px"}}
                                >
                                    <Column field="ID_reservation"  body={<Skeleton />}   header="الحجز" sortable style={{ width: '2%',textAlign:"right" }}></Column>
                                    <Column field="visitor_name"  body={<Skeleton />}  header="العميــل" sortable style={{ width: '10%',textAlign:"right" }}></Column>
                                    <Column field="number" header="الاقامة"  showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                     body={<Skeleton />}  sortable style={{ width: '5%',textAlign:"right" }}></Column>
                                    <Column header="الباقي" field="rest"  body={<Skeleton />}  sortable style={{ width: '5%',textAlign:"right",color:"red" }} ></Column>
                                    <Column field="notes" header="ملاحظات"  body={<Skeleton />}  style={{ width: '5%',textAlign:"right" }}></Column>
                                </DataTable>
                                :
                                <DataTable value={CheckOutToday} loading={loading_checkout}
                                    dataKey="ID_reservation"
                                    selectionMode="multiple"
                                    metaKeySelection={false} dragSelection
                                    stripedRows removableSort
                                    // paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                    scrollable scrollHeight="300px"
                                    sortMode="multiple"
                                    className="custom-scrollbar"
                                    size="small"
                                    emptyMessage={<center><h5> لا يــوجد مغــادرة اليــوم</h5></center>}
                                    tableStyle={scrollStyle}
                                    style={{fontFamily:"Cairo",direction:"rtl",fontSize: "15px",border: "10px"}}
                                >
                                    <Column field="ID_reservation" body={ID_reservationBodyTemplate}  header="الحجز" sortable style={{ width: '2%',textAlign:"right" }}></Column>
                                    <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%',textAlign:"right" }}></Column>
                                    <Column field="number" header="الاقامة"  showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                    body={ApartmentBodyTemplate} sortable style={{ width: '5%',textAlign:"right" }}></Column>
                                    <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '5%',textAlign:"right",color:"red" }} ></Column>
                                    <Column field="notes" header="ملاحظات" style={{ width: '5%',textAlign:"right" }}></Column>
                                </DataTable>
                            }
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="ibox">
                            <div className="ibox-head">
                                <div className="ibox-title">
                                  الحجوزات الحالية   ( {view_day_ar(new Date())}  {moment(new Date()).format('yyyy-MM-DD')} )
                                </div>
                            </div>

                            <div className="ibox-body">
                                <style>{scrollBarCSS}</style>
                                 <DataTable value={bookingnow} loading={loading_checkout}
                                    dataKey="ID_reservation"
                                    selectionMode="multiple"
                                    metaKeySelection={false} dragSelection
                                    stripedRows removableSort
                                    // paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50]}
                                    scrollable scrollHeight="450px"
                                    sortMode="multiple"
                                    className="custom-scrollbar"
                                    size="normal"
                                    emptyMessage={<center><h4>لا يوجد حجوزات</h4></center>}
                                    tableStyle={scrollStyle}
                                    style={{fontFamily:"Cairo",direction:"rtl",fontSize: "15px",border: "10px"}}
                                >
                                    <Column field="ID_reservation" body={ID_reservationBodyTemplate}  header="الحجز" sortable style={{ width: '2%',textAlign:"right" }}></Column>
                                    <Column field="visitor_name" body={CustomerTemplate} header="العميــل" sortable style={{ width: '10%',textAlign:"right" }}></Column>
                                    <Column field="number" header="الاقامة"  showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                    body={ApartmentBodyTemplate} sortable style={{ width: '5%',textAlign:"right" }}></Column>
                                    <Column field="date_check_in" header="الاستلام" body={Date_CheckInBodyTemplate} sortable  style={{ width: '10%',textAlign:"right" }}></Column>
                                    <Column field="date_check_out" header="المغادرة" body={Date_CheckOutBodyTemplate} sortable style={{ width: '10%',textAlign:"right" }}></Column>
                                    <Column field="date_check_in" header="الايام" body={View_count_days}  style={{ width: '1%',textAlign:"right" }}></Column>
                                    <Column field="total_price" header="السعر"   body={Total_PriceBodyTemplate}  sortable style={{ width: '5%',textAlign:"right" }}></Column>
                                    <Column field="total_paid" header="المدفوع" body={Total_PaidBodyTemplate} sortable style={{ width: '5%',textAlign:"right",color:"green" }}></Column>
                                    <Column header="الباقي" field="rest" body={statusBodyTemplate} sortable style={{ width: '5%',textAlign:"right",color:"red" }} ></Column>
                                    <Column field="discount_value" header="التخفيض" body={Total_discound_valueBodyTemplate}   sortable style={{ width: '5%',textAlign:"right" }}></Column>
                                    <Column field="notes" header="ملاحظات" style={{ width: '5%',textAlign:"right" }}></Column>
                                    <Column field="name" header="الحجز عن طريق" style={{ width: '10%',textAlign:"right" }}></Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <style>
                    .visitors-table tbody tr td:last-child {
                        display: flex;
                        align-items: center;
                    }

                    .visitors-table .progress {
                        flex: 1;
                    }

                    .visitors-table .progress-parcent {
                        text-align: right;
                        margin-left: 10px;
                    }
                </style> */}
            </div>

            <footer className="page-footer" >
                <div className="font-13">{moment(new Date()).format("YYYY")} ©  جميع الحقوق محفوظة  - <b>YourSummer v1.1.3 </b> </div>
                <a className="px-4" href="https://github.com/hamzahamruni" target="_blank" rel="noreferrer"> Hamza Hamruni <i className="fa fa-github"></i></a>
                <div className="to-top"><i className="fa fa-angle-double-up"></i></div>
            </footer>
        </div>
    </div>
    )
}

export default Home


